export default {
    title:"易瘦健康",
    lang_one:"语言",
    Scan:"扫码咨询减重顾问",
    drugs_title:"GLP-1作用机理",
    drugs_title1:"GLP-1通过产生「饱足感」与「饱腹感」帮助减少食物摄入，降低每日摄入总热量，从而达到帮助减肥的效果。",
    rig_one:"GLP-1受体激动剂",
    rig_one1:"生成速度快，可按需自行补充",
    rig_one2:"不会被酶分解，更长久和稳定",
    rig_two:"获批国内减肥适应症的GLP-1受体激动剂成分为：利拉鲁肽、贝那鲁肽等",
    rig_two1:"获批国外部分国家减肥适应症的GLP-1受体激动剂成分有：司美格鲁肽、替尔泊肽等",
    rig_three:"先来算一下自己的BMI：BMI（身体质量指数）= 体重（kg）÷ 身高²（m²）",
    med_tle1:"我们提供最全的GLP-1药物网络",
    med_tle2:"对患者负责是我们的责任",
    document_tle1:"药品齐全",
    documents_fter:"香港卫生署授权正规新特药品进出口批发商",
    swiper_tle:"研究人员怎么说",
    med_tle3:"用户口碑及数据",
    praise_tel_title1:"客户",
    praise_tel_title2:"平均体重减轻",
    praise_tel_title3:"用户表示有效",
    praise_tel_title4:"用户表示易于维持体重",
    praise_tel_title5:"平均腰围减少",
    introduce_con_til:"了解易瘦健康",
    introduce_con_til1:"易瘦健康，让减重更简单",
    introduce_con_con:"我们致力于成为减重领域的领航者,专注于帮助消费者实现健康减重,从而显著提升他们的生活质量。",
    med_tle4:"选择易瘦健康 五大理由",
    reason_mod_contil1:"专业健康管理团队",
    reason_mod_conto1:"我们汇集了一批经验丰富的健康专家，他们对减肥药品和健康管理方案有深入的研究和实践，确保您获得最专业、最科学的指导和服务。",
    reason_mod_contil2:"安全有效的减重方案",
    reason_mod_conto2:"易瘦健康提供的所有产品和服务都经过严格的筛选和测试，确保安全有效。我们的目标是帮助您以健康的方式减重，避免对身体造成任何伤害。",
    reason_mod_contil3:"个性化的健康管理计划",
    reason_mod_conto3:"易瘦健康专注于为每位消费者提供个性化的健康管理计划，结合您的具体情况，制定最合适您的减肥方案，确保减重效果显著且持久。",
    reason_mod_contil4:"领航者的品牌信誉",
    reason_mod_conto4:"易瘦健康一直致力于成为行业的标杆。我们以高质量的服务和产品赢得了广泛的好评和信任，选择我们，就是选择了信誉和保障。",
    reason_mod_contil5:"显著提升生活质量",
    reason_mod_conto5:"健康生活，源自专业。易瘦健康不仅帮助您实现健康减重，更关注于提升您的整体生活质量。让您在享受健康的同时，也能享受到生活的美好。",
    med_tle5:"司美常见问题",
    hotline_rig_tle1:"服务热线",
    hotline_rig_tle2:"地址",
    hotline_rig_pho:"香港旺角花园街2-16号好景商业中心5楼",
    account:"扫码关注公众号",
    client:"联系官方客服"
}